const selectors = {
	youkuContainer: '.ThirdPartyVideo-youku-container',
};

///////////////////////////////
const renderPlayers = (container = window.document) => {
	const $container = $(container);
	$container.find(selectors.youkuContainer).each(function () {
		const $playerContainer = $(this);
		const id = $playerContainer.data('id');
		const src = $playerContainer.data('src');

		$playerContainer.append(
			$('<iframe>', {
				id: `ThirdPartyVideo-iframe-${id}`,
				class: 'ThirdPartyVideo-iframe',
				width: '100%',
				height: '100%',
				'aria-describedby': `ThirdPartyVideo-description-${id}`,
				src,
				'data-src': src,
				frameborder: 0,
				allowfullscreen: true,
				'aria-labelledby': `ThirdPartyVideo-description-${id}`,
			})
		);
	});
};

///////////////////////////////
const removePlayers = (container = window.document) => {
	const $container = $(container);

	$container.find(selectors.youkuContainer).each(function () {
		const $playerContainer = $(this);

		//remove whatever elements there might be
		$playerContainer.html(
			'<div><p>Video player is disabled. To enable, please enable Functional Cookies via the Cookie Preferences link in the footer and reload the page.</p></div>'
		);
	});
};

///////////////////////////////
export default function initPlayers(container = window.document) {
	//only try to initialize on pages that actually have a youku video
	if ($(selectors.youkuContainer).length) {
		//if permission group X exists in OnetrustActiveGroups then proceed
		window.FS.GDPR.getSavedConsent(({ functional: hasPermission }) => {
			//runs if permission is granted
			if (hasPermission) {
				renderPlayers(container);
			} else {
				removePlayers(container);
			}
		});
	}
}
